import React from 'react';

import { NotificationPreferences } from './XomicsNotifications';
import { Head } from './parts';
import { SessionList } from './Sessions';
import { tx } from './i18n';

// Settings is what you change about how the portal behaves for you. Who you
// are lives on Profile, reachable from the avatar top right — the two got
// merged into one "Account" screen before, which meant editing your phone
// number and revoking a session in another country looked like the same kind
// of act.
export default function XomicsSettings() {
  return (
    <div className="xo-account-settings-page">
      <Head
        title={tx("ui.settings.settings_c7f73bb5")}
        subtitle={tx("ui.settings.how_the_portal_reaches_you_and_where_you_are_signed_in_80a5dc6a")}
      />
      <div className="xo-account-settings-layout">
        <NotificationPreferences />
        <SessionList />
      </div>
    </div>
  );
}
